<div class="justify-center px-[30px] py-[20px]" isOpen="true">
  <!-- <ion-content> -->
    <div class="flex flex-col items-center gap-[10px]">
      <ark-lib-icon-name name="success"></ark-lib-icon-name>
      <div>
        <h3 class="text-center">Your commitment level has been set.</h3>
      </div>
      <div>
        <h3 class="text-center">Click below to follow this {{postTypeLabel}}.</h3>
      </div>
    </div>

    <div class="mt-[40px] flex flex-col w-full">
      <ark-button 
      leftIcon="system-star"
      class="w-full"
      (click)="onFollowClick()"
      >FOLLOW</ark-button>

      <ark-button
      classess="w-full"
      type="light"
      leftIcon="system-left"
      [iconColor]="'#14192D'"
      (click)="onCancelClick()"
      >Cancel</ark-button>
    </div>
  <!-- </ion-content> -->
</div>